const STAMP_KEYS = ['lastModifiedAt', 'lastUpdatedBy'];

export function isRichCell(cell) {
  return Boolean(cell) && typeof cell === 'object' && !Array.isArray(cell);
}

export function cellContent(cell) {
  if (cell == null) {
    return '';
  }
  if (!isRichCell(cell)) {
    return cell;
  }
  const content = {};
  Object.keys(cell).forEach((key) => {
    if (!STAMP_KEYS.includes(key)) {
      content[key] = cell[key];
    }
  });
  const keys = Object.keys(content);
  if (keys.length === 0) {
    return '';
  }
  if (keys.length === 1 && keys[0] === 'value') {
    return content.value == null ? '' : content.value;
  }
  return content;
}

export function cellStamp(cell) {
  if (!isRichCell(cell) || !cell.lastModifiedAt) {
    return null;
  }
  const time = Date.parse(cell.lastModifiedAt);
  return Number.isNaN(time) ? null : time;
}

export function sameCellContent(left, right) {
  const leftContent = cellContent(left);
  const rightContent = cellContent(right);
  if (leftContent === rightContent) {
    return true;
  }
  if (typeof leftContent === 'object' && typeof rightContent === 'object') {
    return JSON.stringify(leftContent) === JSON.stringify(rightContent);
  }
  return false;
}

export function isLocalCellNewer(localCell, serverCell) {
  const localStamp = cellStamp(localCell);
  const serverStamp = cellStamp(serverCell);
  return (
    localStamp != null && (serverStamp == null || localStamp > serverStamp)
  );
}

export function stripHtml(value) {
  return String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function cellDisplayText(cell) {
  const content = cellContent(cell);
  if (content == null || content === '') {
    return '';
  }
  if (typeof content === 'boolean') {
    return content ? '✓' : '';
  }
  if (typeof content !== 'object') {
    return stripHtml(content);
  }
  if (Array.isArray(content.options)) {
    return content.options
      .filter((option) => option.checked)
      .map((option) => stripHtml(option.defaultMC || ''))
      .filter(Boolean)
      .join(', ');
  }
  if (content.value === true) {
    return '✓';
  }
  if (content.value == null || content.value === false) {
    return '';
  }
  return stripHtml(content.value);
}
